import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  InjectionToken,
  Input,
  Optional,
  Output,
} from '@angular/core';

export interface SdOptionParent {
  selectOption(option: SdOption): void;
  isOptionSelected(option: SdOption): boolean;
}

export const SD_OPTION_PARENT = new InjectionToken<SdOptionParent>('SD_OPTION_PARENT');

@Component({
  selector: 'sd-option',
  standalone: true,
  template: `
    <button
      type="button"
      class="flex w-full items-center rounded-md px-3 py-2 text-left text-sm hover:bg-neutral-50 disabled:opacity-50"
      [class.font-semibold]="selected"
      [class.bg-neutral-100]="selected"
      [disabled]="disabled"
      (click)="onClick($event)"
    >
      <ng-content></ng-content>
    </button>
  `,
  host: {class: 'sd-option block', role: 'option'},
})
export class SdOption {
  @Input() value: unknown;
  @Input() disabled = false;
  @Output() selectionChange = new EventEmitter<SdOption>();

  constructor(
    private readonly elementRef: ElementRef<HTMLElement>,
    @Optional() @Inject(SD_OPTION_PARENT) private readonly parent: SdOptionParent | null,
  ) {}

  get selected(): boolean {
    return this.parent?.isOptionSelected(this) ?? false;
  }

  get viewValue(): string {
    return this.elementRef.nativeElement.innerText?.trim() || String(this.value ?? '');
  }

  onClick(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    if (this.disabled) {
      return;
    }
    this.selectionChange.emit(this);
    this.parent?.selectOption(this);
  }

  deselect(): void {}
  select(): void {
    this.parent?.selectOption(this);
  }
}
